import type { FunctionComponent } from 'react'
import React from 'react'

import { Icon } from '../../Icon'
import type { Icon as IconProps } from '../../Icon/Icon'
import styles from '../Icons.module.scss'

export const PageIcon: FunctionComponent<IconProps> = ({
  fill,
  width = 30,
  height = 30,
  ...rest
}) => {
  return (
    <Icon fill={fill} height={height} viewBox={`0 0 ${width} ${height}`} width={width} {...rest}>
      <g fill="none" fillRule="evenodd" stroke="none" strokeWidth="1">
        <g id="Artboard" transform="translate(-561.000000, -46.000000)">
          <g id="Group-17" transform="translate(561.000000, 46.000000)">
            <path
              d="M0,15 C0,23.284 6.716,30 15,30 C23.284,30 30,23.284 30,15 C30,6.716 23.284,0 15,0 C6.716,0 0,6.716 0,15"
              fill="#FF4D52"
              id="Fill-1"
            />
            <path
              d="M9,22.3521 C9,22.8631 9.418,23.2801 9.928,23.2801 L20.346,23.2801 C20.856,23.2801 21.274,22.8631 21.274,22.3521 L21.274,11.0821 C21.274,10.5721 20.991,9.8471 20.645,9.4721 L18.549,7.2001 C18.203,6.8241 17.502,6.5171 16.992,6.5171 L9.928,6.5171 C9.418,6.5171 9,6.9351 9,7.4451 L9,22.3521 Z"
              fill="#ffffff"
              className={styles.white}
              id="Fill-3"
            />
            <polyline
              id="Stroke-5"
              points="17.92 6.5173 17.92 10.1643 21.274 10.1543"
              stroke="#FF4D52"
              strokeLinejoin="round"
              strokeWidth="0.5"
            />
            <line
              id="Stroke-7"
              stroke="#FF4D52"
              strokeLinejoin="round"
              strokeWidth="0.5"
              x1="11.3298"
              x2="18.4048"
              y1="12.505"
              y2="12.505"
            />
            <line
              id="Stroke-9"
              stroke="#FF4D52"
              strokeLinejoin="round"
              strokeWidth="0.5"
              x1="11.3298"
              x2="18.4048"
              y1="15.9482"
              y2="15.9482"
            />
            <line
              id="Stroke-11"
              stroke="#FF4D52"
              strokeLinejoin="round"
              strokeWidth="0.5"
              x1="11.3298"
              x2="18.4048"
              y1="14.2212"
              y2="14.2212"
            />
            <line
              id="Stroke-13"
              stroke="#FF4D52"
              strokeLinejoin="round"
              strokeWidth="0.5"
              x1="11.3298"
              x2="18.4048"
              y1="19.5952"
              y2="19.5952"
            />
            <line
              id="Stroke-15"
              stroke="#FF4D52"
              strokeLinejoin="round"
              strokeWidth="0.5"
              x1="11.3298"
              x2="18.4048"
              y1="17.8681"
              y2="17.8681"
            />
          </g>
        </g>
      </g>
    </Icon>
  )
}
